module.exports = require('./readable').PassThrough



//////////////////
// WEBPACK FOOTER
// ../~/readable-stream/passthrough.js
// module id = 768
// module chunks = 0